import React, { FC, useMemo } from 'react';
// import { Tabs } from 'antd';
import styles from './styles.module.less';
// import classnames from 'classnames';

// export const AuthingTabs: FC<AuthingTabsProps> = props => {
// 	console.log('??????', props);
// 	const renderTabBar: (props: any, DefaultTabBar: React.ComponentType) => React.ReactElement = props => {
// 		const { panes, activeKey, onTabClick } = props;

// 		return (
// 			<div>
// 				<div className={`${styles.tabBar} __authing-tab-bar`}>
// 					{panes.map((pane: any, index: number) => {
// 						const iActive = pane.key === activeKey;
// 						const cls = classnames(styles.tab, {
// 							[styles.active]: iActive
// 						});
// 						const isFirst = index === 0;
// 						const split = <div className={styles.split} />;
// 						return (
// 							<Fragment key={pane.key}>
// 								{isFirst ? null : split}
// 								<span className={cls} key={pane.key} onClick={e => onTabClick(pane.key, e)}>
// 									{pane.props.tab}
// 								</span>
// 							</Fragment>
// 						);
// 					})}
// 				</div>
// 			</div>
// 		);
// 	};

// 	return (
// 		<Tabs renderTabBar={renderTabBar} {...props}>
// 			{props.children}
// 		</Tabs>
// 	);
// };

import { Button } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';

import classnames from 'classnames';

export const AuthingTabs: FC<any> = props => {
	const { activeKey, className, onChange } = props;
	const showLen = 3;
	const panes = props.children;
	const activeIndex = useMemo(() => panes.findIndex((item: any) => item.key === activeKey), [activeKey, panes]);

	const showTabs = useMemo(() => {
		if (panes.length <= showLen) {
			return [...panes];
		}

		let startIndex = Math.max(activeIndex - 1, 0);
		if (startIndex + showLen > panes.length - 1) {
			startIndex = panes.length - showLen;
		}

		return panes.slice(startIndex, startIndex + showLen);
	}, [activeIndex, panes]);

	const hideTabs = useMemo(() => {
		const showKeys = showTabs.map((item: any) => item.key);
		return panes.filter((item: any) => !showKeys.find((key: any) => item.key === key));
	}, [panes, showTabs]);

	const currentPane = useMemo(() => {
		return panes.filter((item: any) => item.key === activeKey)[0];
	}, [activeKey, panes]);

	return (
		<>
			<div className={classnames(styles['authing-tabs'], className)}>
				<div
					className={classnames(
						styles['authing-tabs-inner'],
						Boolean(hideTabs.length) && styles['authing-tabs-inner--more']
					)}
				>
					{showTabs.map((item: any, index: number) => (
						<div
							onClick={() => onChange(item.key)}
							className={classnames(
								styles['authing-tab-item'],
								activeKey === item.key && styles['authing-tab-item__active']
							)}
							key={item.key}
						>
							{item.props.tab}
						</div>
					))}
				</div>
				{Boolean(hideTabs.length) && (
					<Button
						className={styles["authing-tabs-show-more"]}
						type="text"
						icon={<EllipsisOutlined />}
					>
						<ul className={styles["authing-tabs-more-panel"]}>
							{hideTabs.map((item: any) => (
								<li
									key={item.key}
									onClick={() => onChange(item.key)}
									className={styles["authing-tabs-more-panel-item"]}
								>
									{item.props.tab}
								</li>
							))}
						</ul>
					</Button>
				)}
			</div>
			<div className={classnames(styles['authing-tab-pane'])}>{currentPane && currentPane.props.children}</div>
		</>
	);
};
